import type { PortableTextComponentProps } from '@portabletext/react';
import type { WineStyleProps } from '../components/WineStyle';
import { WineStyle, wineStyleGroq } from '../components/WineStyle';
import type { DefinitionItemProps } from '../grid/DefinitionItem';
import DefinitionItem, { definitionItemGroq } from '../grid/DefinitionItem';
import type { DrinkRecipeProps } from '../grid/DrinkRecipe';
import DrinkRecipe, { drinkRecipeGroq } from '../grid/DrinkRecipe';
import type { GrapeItemProps } from '../grid/GrapeItem';
import GrapeItem, { grapeItemGroq } from '../grid/GrapeItem';
import type { PodcastProps } from './Podcast';
import { Podcast, podcastGroq } from './Podcast';

interface ComponentProps {
    _key: string;
    reference?: WineStyleProps | DefinitionItemProps | GrapeItemProps | DrinkRecipeProps | PodcastProps;
}

export const componentGroq = /* groq */ `{
  _type,
  _key,
  'reference': @ -> {
      _type == 'definition' => ${definitionItemGroq},
      _type == 'grape' => ${grapeItemGroq},
      _type == 'wineStyle' => ${wineStyleGroq},
      _type == 'drinkRecipe' => ${drinkRecipeGroq},
      _type == 'podcast' => ${podcastGroq}
  }
}`;

export function Component({ value }: PortableTextComponentProps<ComponentProps>) {
    if (!value.reference) return null;
    switch (value.reference._type) {
        case 'wineStyle':
            return <WineStyle wineStyle={value.reference} />;
        case 'definition':
            return <DefinitionItem {...value.reference} />;
        case 'grape':
            return <GrapeItem {...value.reference} />;
        case 'drinkRecipe':
            return <DrinkRecipe {...value.reference} />;
        case 'podcast':
            return <Podcast {...value.reference} />;
    }
}
